module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h2', {
    staticClass: "page-header"
  }, [_c('span', {
    attrs: {
      "id": "page-header"
    }
  }, [_vm._v(_vm._s(_vm.pageheader))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h3', {
    staticClass: "col-lg-12"
  }, [_vm._v("Allgemeine Informationen  "), _c('router-link', {
    staticClass: "btn btn-primary create-new pull-right",
    attrs: {
      "to": "/graves/new"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal",
    attrs: {
      "id": "customer-information"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Art "), _c('span', {
    staticStyle: {
      "color": "#f00",
      "font-weight": "800"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type_id),
      expression: "type_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.type_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("[Nicht spezifiziert]")]), _vm._v(" "), _vm._l((_vm.$store.getters.models('grave_types')), function(gtype) {
    return _c('option', {
      domProps: {
        "value": gtype.id
      }
    }, [_vm._v(_vm._s(gtype.name))])
  })], 2)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "grave_name"
    }
  }, [_vm._v("Name "), _c('span', {
    staticStyle: {
      "color": "#f00",
      "font-weight": "800"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.name),
      expression: "model.model.name"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "grave_name",
      "id": "grave_name",
      "required": ""
    },
    domProps: {
      "value": (_vm.model.model.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.name = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "grave_area"
    }
  }, [_vm._v("Fläche (" + _vm._s(_vm.model.model.category_name) + ")  "), _c('span', {
    staticStyle: {
      "color": "#f00",
      "font-weight": "800"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.area_name),
      expression: "model.model.area_name"
    }],
    staticClass: "form-control",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "grave_area",
      "name": "grave_area",
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.model.model.area_name)
    },
    on: {
      "click": function($event) {
        _vm.selectArea()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.area_name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon addon-primary",
    on: {
      "click": function($event) {
        _vm.selectArea()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]), _vm._v(" "), (_vm.model.model.area_id > 0) ? _c('router-link', {
    staticClass: "input-group-addon addon-success",
    attrs: {
      "to": '/areas/' + _vm.model.model.area_id
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  })]) : _vm._e()], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "grave_price"
    }
  }, [_vm._v("Preis (Fläche: " + _vm._s(_vm.area_price) + " €)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.price),
      expression: "model.model.price"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "grave_price",
      "name": "grave_price",
      "required": "required",
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.model.model.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.price = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "grave_description"
    }
  }, [_vm._v("Beschreibung")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.description),
      expression: "model.model.description"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "grave_description",
      "id": "grave_description",
      "required": "required"
    },
    domProps: {
      "value": (_vm.model.model.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-lg-12 text-center"
  }, [_vm._m(1), _vm._v(" "), (_vm.validGrave) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.saveGrave()
      }
    }
  }, [_vm._v("Speichern")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.model.id > 0),
      expression: "model.model.id > 0"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "tab-content col-lg-12"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "customers"
    }
  }, [_c('custom-table', {
    attrs: {
      "cols": _vm.customerCols,
      "src-model": _vm.model.customers,
      "add": "",
      "delete": "",
      "edit": "",
      "nosort": "",
      "select": "/customers/{:customer_id}",
      "default-sort": _vm.defSort
    },
    on: {
      "add": function($event) {
        _vm.addRelation('customers')
      },
      "edit": _vm.editCustomer,
      "delete": _vm.deleteCustomer
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "deceaseds"
    }
  }, [_c('custom-table', {
    attrs: {
      "cols": _vm.deceasedsCols,
      "src-model": _vm.model.deceaseds,
      "add": "",
      "edit": "",
      "delete": "",
      "nosort": "",
      "select": "/deceaseds/{:deceased_id}",
      "default-sort": _vm.defSort
    },
    on: {
      "add": function($event) {
        _vm.addRelation('deceaseds')
      },
      "edit": _vm.editDeceased,
      "delete": _vm.deleteDeceased
    }
  })], 1)])])])])], 1)])]), _vm._v(" "), (_vm.visibleModal === 'selectArea') ? _c('custom-modal', {
    attrs: {
      "title": _vm.selectAreaMode === 'new' ? 'Fläche anlegen' : 'Fläche auswählen',
      "ok-style": "btn btn-primary",
      "ok-text": _vm.selectAreaMode === 'new' ? 'Speichern' : null
    },
    on: {
      "cancel": function($event) {
        _vm.visibleModal = ''
      },
      "ok": function($event) {
        _vm.newArea()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('button', {
    staticClass: "btn btn-default btn-sm",
    on: {
      "click": function($event) {
        _vm.selectAreaMode = 'relation'
      }
    }
  }, [_vm._v("Auswählen")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    on: {
      "click": function($event) {
        _vm.selectAreaMode = 'new'
      }
    }
  }, [_vm._v("Hinzufügen")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [(_vm.selectAreaMode === 'relation') ? _c('custom-table', {
    attrs: {
      "row-add": "",
      "src-model": _vm.$store.getters.models('areas'),
      "cols": _vm.areaCols,
      "store": "areas",
      "search": "",
      "default-sort": _vm.defSort
    },
    on: {
      "rowAdd": _vm.pickArea
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectAreaMode === 'new') ? _c('div', [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.areas.model.name),
      expression: "areas.model.name"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "name",
      "required": ""
    },
    domProps: {
      "value": (_vm.areas.model.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.areas.model.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Beschreibung")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.areas.model.description),
      expression: "areas.model.description"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "description",
      "required": ""
    },
    domProps: {
      "value": (_vm.areas.model.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.areas.model.description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "price"
    }
  }, [_vm._v("Preis")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.areas.model.price),
      expression: "areas.model.price"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "price",
      "required": ""
    },
    domProps: {
      "value": (_vm.areas.model.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.areas.model.price = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "coordinates"
    }
  }, [_vm._v("Koordinaten")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.areas.model.coordinates),
      expression: "areas.model.coordinates"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "coordinates",
      "required": ""
    },
    domProps: {
      "value": (_vm.areas.model.coordinates)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.areas.model.coordinates = $event.target.value
      }
    }
  })])])], 1) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.visibleModal === 'selectGraveType') ? _c('custom-modal', {
    attrs: {
      "title": "Art des Grabes auswählen"
    },
    on: {
      "cancel": function($event) {
        _vm.visibleModal = ''
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('custom-table', {
    attrs: {
      "row-add": "",
      "src-model": _vm.$store.getters.models('grave_types'),
      "cols": _vm.graveTypeCols,
      "store": "grave_types",
      "search": "",
      "default-sort": _vm.defSort
    },
    on: {
      "rowAdd": _vm.pickGraveType
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.visibleModal === 'adddeceaseds') ? _c('custom-modal', {
    attrs: {
      "title": "Verstorbenen zuweisen",
      "cancel-text": "Abbrechen",
      "cancel-style": "btn btn-default"
    },
    on: {
      "cancel": function($event) {
        _vm.visibleModal = ''
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-10"
  }, [_c('custom-input', {
    attrs: {
      "title": "Verstorbener"
    }
  }, [_c('custom-table', {
    attrs: {
      "row-add": "",
      "src-model": _vm.$store.getters.models('deceaseds'),
      "cols": _vm.deceasedSearchCols,
      "store": "deceaseds",
      "search": "",
      "default-sort": _vm.defSort
    },
    on: {
      "rowAdd": _vm.saveDeceased
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('custom-input', {
    attrs: {
      "title": "Von"
    }
  }, [_c('datepicker', {
    attrs: {
      "bootstrapStyling": "",
      "calendar-button": "",
      "calendar-button-icon": "fa fa-calendar",
      "name": "from",
      "required": "",
      "language": "de",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.deceaseds.model.from),
      callback: function($$v) {
        _vm.deceaseds.model.from = $$v
      },
      expression: "deceaseds.model.from"
    }
  })], 1), _vm._v(" "), _c('custom-input', {
    attrs: {
      "title": "Bis"
    }
  }, [_c('datepicker', {
    attrs: {
      "bootstrapStyling": "",
      "calendar-button": "",
      "calendar-button-icon": "fa fa-calendar",
      "name": "until",
      "required": "",
      "language": "de",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.deceaseds.model.until),
      callback: function($$v) {
        _vm.deceaseds.model.until = $$v
      },
      expression: "deceaseds.model.until"
    }
  })], 1)], 1)])]) : _vm._e(), _vm._v(" "), (_vm.visibleModal === 'editdeceaseds') ? _c('custom-modal', {
    attrs: {
      "title": "Verstorbenen bearbeiten",
      "ok-text": "Aktualisieren",
      "cancel-text": "Abbrechen",
      "cancel-style": "btn btn-default"
    },
    on: {
      "cancel": function($event) {
        _vm.visibleModal = ''
      },
      "ok": _vm.updateDeceased
    }
  }, [_c('custom-input', {
    attrs: {
      "title": "Von"
    }
  }, [_c('datepicker', {
    attrs: {
      "bootstrapStyling": "",
      "calendar-button": "",
      "calendar-button-icon": "fa fa-calendar",
      "name": "from",
      "required": "",
      "language": "de",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.deceaseds.model.from),
      callback: function($$v) {
        _vm.deceaseds.model.from = $$v
      },
      expression: "deceaseds.model.from"
    }
  })], 1), _vm._v(" "), _c('custom-input', {
    attrs: {
      "title": "Bis"
    }
  }, [_c('datepicker', {
    attrs: {
      "bootstrapStyling": "",
      "calendar-button": "",
      "calendar-button-icon": "fa fa-calendar",
      "name": "until",
      "required": "",
      "language": "de",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.deceaseds.model.until),
      callback: function($$v) {
        _vm.deceaseds.model.until = $$v
      },
      expression: "deceaseds.model.until"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.visibleModal === 'deletedeceaseds') ? _c('custom-modal', {
    attrs: {
      "title": "Verstorbenen entfernen",
      "ok-text": "Löschen",
      "cancel-text": "Abbrechen",
      "ok-style": "btn btn-danger"
    },
    on: {
      "ok": function($event) {
        _vm.confirmDeleteRelation('deceaseds')
      },
      "cancel": function($event) {
        _vm.visibleModal = ''
      }
    }
  }, [_c('strong', [_vm._v("Sind Sie sicher, dass Sie das Grab entfernen möchten?")])]) : _vm._e(), _vm._v(" "), (_vm.visibleModal === 'addcustomers') ? _c('custom-modal', {
    attrs: {
      "title": "Nutzungsberechtigten hinzufügen",
      "cancel-text": "Abbrechen",
      "cancel-style": "btn btn-default"
    },
    on: {
      "cancel": function($event) {
        _vm.visibleModal = ''
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-10"
  }, [_c('custom-input', {
    attrs: {
      "title": "Kunde"
    }
  }, [_c('custom-table', {
    attrs: {
      "row-add": "",
      "src-model": _vm.$store.getters.models('customers'),
      "cols": _vm.customerSearchCols,
      "store": "customers",
      "search": "",
      "default-sort": _vm.defSort
    },
    on: {
      "rowAdd": _vm.saveCustomer
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('custom-input', {
    attrs: {
      "title": "Von"
    }
  }, [_c('datepicker', {
    attrs: {
      "bootstrapStyling": "",
      "calendar-button": "",
      "calendar-button-icon": "fa fa-calendar",
      "name": "from",
      "required": "",
      "language": "de",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.customers.model.from),
      callback: function($$v) {
        _vm.customers.model.from = $$v
      },
      expression: "customers.model.from"
    }
  })], 1), _vm._v(" "), _c('custom-input', {
    attrs: {
      "title": "Bis"
    }
  }, [_c('datepicker', {
    attrs: {
      "bootstrapStyling": "",
      "calendar-button": "",
      "calendar-button-icon": "fa fa-calendar",
      "name": "until",
      "required": "",
      "language": "de",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.customers.model.until),
      callback: function($$v) {
        _vm.customers.model.until = $$v
      },
      expression: "customers.model.until"
    }
  })], 1)], 1)])]) : _vm._e(), _vm._v(" "), (_vm.visibleModal === 'editcustomers') ? _c('custom-modal', {
    attrs: {
      "title": "Nutzungsberechtigten bearbeiten",
      "ok-text": "Aktualisieren",
      "cancel-text": "Abbrechen",
      "cancel-style": "btn btn-default"
    },
    on: {
      "cancel": function($event) {
        _vm.visibleModal = ''
      },
      "ok": _vm.updateCustomer
    }
  }, [_c('custom-input', {
    attrs: {
      "title": "Von"
    }
  }, [_c('datepicker', {
    attrs: {
      "bootstrapStyling": "",
      "calendar-button": "",
      "calendar-button-icon": "fa fa-calendar",
      "name": "from",
      "required": "",
      "language": "de",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.customers.model.from),
      callback: function($$v) {
        _vm.customers.model.from = $$v
      },
      expression: "customers.model.from"
    }
  })], 1), _vm._v(" "), _c('custom-input', {
    attrs: {
      "title": "Bis"
    }
  }, [_c('datepicker', {
    attrs: {
      "bootstrapStyling": "",
      "calendar-button": "",
      "calendar-button-icon": "fa fa-calendar",
      "name": "until",
      "required": "",
      "language": "de",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.customers.model.until),
      callback: function($$v) {
        _vm.customers.model.until = $$v
      },
      expression: "customers.model.until"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.visibleModal === 'deletecustomers') ? _c('custom-modal', {
    attrs: {
      "title": "Nutzungsberechtigten entfernen",
      "ok-text": "Löschen",
      "cancel-text": "Abbrechen",
      "ok-style": "btn btn-danger"
    },
    on: {
      "ok": function($event) {
        _vm.confirmDeleteRelation('customers')
      },
      "cancel": function($event) {
        _vm.visibleModal = ''
      }
    }
  }, [_c('strong', [_vm._v("Sind Sie sicher, dass Sie diesen Nutzungsberechtigten entfernen möchten?")])]) : _vm._e(), _vm._v(" "), (_vm.visibleModal === 'errSavingModel') ? _c('custom-modal', {
    attrs: {
      "ok-text": "OK"
    },
    on: {
      "ok": function($event) {
        _vm.visibleModal = ''
      },
      "cancel": function($event) {
        _vm.visibleModal = ''
      }
    }
  }, [_vm._v("\r\n\t\t\tFehler beim Speichern des Kunden.\r\n\t\t")]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "hidden-md hidden-lg",
    attrs: {
      "href": "/graves/"
    }
  }, [_c('button', {
    staticClass: "btn btn-success"
  }, [_vm._v("Zur Liste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "hidden-sm hidden-xs",
    attrs: {
      "href": "/graves/"
    }
  }, [_c('button', {
    staticClass: "btn btn-success"
  }, [_vm._v("Zur Liste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs responsive-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#customers"
    }
  }, [_vm._v("Nutzungsberechtigte")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#deceaseds"
    }
  }, [_vm._v("Verstorbene")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3fc6eaf0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/GraveEdit.vue
// module id = 443
// module chunks = 0